module.exports = __webpack_public_path__ + "static/media/raczki.639046e6.png";